import { ClientDataService, IClientDataDoc } from '../../../services/clientData.service'

export class SignaturesService extends ClientDataService {
  private SIG_TYPE_DOC = 'tb_prform_standard_sigtype'
  private SIG_FORM_TEXT_DOC = 'tb_prform_standard'
  private SIG_SEC_TWO_PATIENT_UNABLE_SIGN_DOC = 'tb_standard_sig_unable_sign'
  private CUSTOM_SIGNATURE_OPTIONS = 'tb_prforms_custom'
  private SIGNATURE_TYPE_OPTIONS = 'tb_signature_types'
  private SEC_TWO_AUTHORIZED_REPRESENTATIVE = 'tb_authorized_representative'

  async getSignatureTypes(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SIG_TYPE_DOC)
  }

  async getSignatureFormText(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SIG_FORM_TEXT_DOC)
  }

  async getSignatureSectionTwoPatientUnableToSign(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SIG_SEC_TWO_PATIENT_UNABLE_SIGN_DOC)
  }

  async getCustomSignatureOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CUSTOM_SIGNATURE_OPTIONS)
  }

  async getSignatureTypeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SIGNATURE_TYPE_OPTIONS)
  }

  async getSectionTwoAuthorizedRepresentativeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SEC_TWO_AUTHORIZED_REPRESENTATIVE)
  }
}
